import { gql } from '@apollo/client'

export default gql`
  fragment SkillStatusFragment on SkillEmployeeStatusDto {
    statusId
    employeeId
    skillStatus
    employeeExpireDate
    latestSyncDate
    expired
  }
`
